import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { WuJieBus } from '@analytics/patsnap-copilot/src/wujie-bus';

export const PatsnapCopilotDialogSize = Symbol('PatsnapCopilotDialogSize');

export interface PatsnapCopilotDialogSize {
    /**
     * 展开/收起
     * @param expand 是否展开
     */
    toggle(expand: boolean): void;
}

@injectable()
export class PatsnapCopilotDialogSizeImpl implements PatsnapCopilotDialogSize {
    constructor(
        @inject(WuJieBus)
        private readonly _wujieBus: WuJieBus,
    ) {

    }

    toggle(expand: boolean): void {
        this._wujieBus.$emit('toggle-size', expand);
    }
}
